import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
export const controlClasses = 'w-full rounded-field border border-rule bg-card px-3.5 text-body text-ink placeholder:text-ink-subtle transition-colors focus-visible:outline-none focus-visible:border-primary focus-visible:ring-2 focus-visible:ring-primary/30 aria-[invalid=true]:border-accent disabled:opacity-50';
export function TextInput({
  className = '',
  ...rest
}: React.ComponentProps<'input'>) {
  return <input className={`${controlClasses} min-h-tap ${className}`} {...rest} data-id="element-552" data-mp="3lrdyzn8qjan1" />;
}
export function TextArea({
  className = '',
  rows = 5,
  ...rest
}: React.ComponentProps<'textarea'>) {
  return <textarea rows={rows} className={`${controlClasses} resize-y py-3 ${className}`} {...rest} data-id="element-553" data-mp="3vm5v0mmo5pfp" />;
}
interface SelectOption {
  label: string;
  value: string;
}
interface SelectControlProps extends React.ComponentProps<'select'> {
  options: SelectOption[];
  placeholder?: string;
}
export function SelectControl({
  options,
  placeholder,
  className = '',
  ...rest
}: SelectControlProps) {
  return <div className="relative" data-id="element-554" data-mp="hygur9na8no5">
      <select className={`${controlClasses} min-h-tap appearance-none pr-10 ${className}`} {...rest} data-id="element-555" data-mp="d0f3i1fpdi1l">
        {placeholder ? <option value="" disabled data-id="element-556" data-mp="8x0mp8jxwxn3">
            {placeholder}
          </option> : null}
        {options.map(option => <option key={option.value} value={option.value} data-id="element-557" data-mp="3v5s2hktu4lcz">
            {option.label}
          </option>)}
      </select>
      <ChevronDownIcon aria-hidden="true" className="pointer-events-none absolute right-3.5 top-1/2 h-4 w-4 -translate-y-1/2 text-ink-muted" data-id="element-558" data-mp="3qetk8fpadd73" />
    </div>;
}